export const supportedResources = ['Patient'] as const;
export type SupportedResourceType = (typeof supportedResources)[number];
export const supportedResourceSet = new Set(supportedResources);
